<template>
    <div class="profile">
        <UserInfo v-if="currentUser"
                :user="currentUser"
        ></UserInfo>

        <Button class="btn" title="Edit" @click="openEditUserModal(currentUserId)"><i class="icon-pencil"></i> Edit</Button>
        <Button class="btn red" title="Delete" @click="openDeleteUserModal(currentUserId)"><i class="icon-trash-empty"></i> Delete</Button>

        <EditUserModal v-if="displayEditUserModal"
                       :user="userToEdit"
                       @closeModal="closeEditUserModal"
        ></EditUserModal>

        <DeleteUserModal v-if="displayDeleteUserModal"
                         :user="userToDelete"
                         @deleted="deleted"
                         @closeModal="closeDeleteUserModal"
        ></DeleteUserModal>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import UserInfo from "../UserInfo";
    import Button from "../../../../components/Button";
    import EditUserModal from "../EditUserModal";
    import DeleteUserModal from "../DeleteUserModal";

    export default {
        name: "UserProfile",

        components: {
            DeleteUserModal,
            EditUserModal,
            Button,
            UserInfo,
        },

        data() {
            return {
                userToEdit: null,
                userToDelete: null,
                displayEditUserModal: false,
                displayDeleteUserModal: false,
            }
        },

        computed: {
            ...mapState('users', [
                'currentUserId',
            ]),

            ...mapGetters('users', [
                'currentUser',
            ]),

        },

        methods: {
            ...mapActions('users', [
                'getUser',
            ]),

            deleted() {
                this.$router.push({ name: 'users' })
            },

            async openEditUserModal(userId) {
                this.userToEdit = await this.getUser(userId);

                this.displayEditUserModal = true;
            },

            closeEditUserModal() {
                // clear variable
                this.userToEdit = null;

                this.displayEditUserModal = false;
            },

            async openDeleteUserModal(userId) {
                this.userToDelete = await this.getUser(userId);

                this.displayDeleteUserModal = true;
            },

            closeDeleteUserModal() {
                // clear variable
                this.userToDelete = null;

                this.displayDeleteUserModal = false;
            },

        },
        
    }
</script>

<style scoped>
    .profile {
        margin: -1em 0 0;
    }

    button {
        margin-right: 10px;
    }
</style>